<template>
  <section class="promoPacketModal">
    <a class="confectionRow__link pointer" @click="open1=true"><i class="glyphicon glyphicon-info-sign mr-2"></i>Szczegóły</a>
    <modal v-model="open1" size="lg" class="custom-modal" :footer="false">
      <template #header>
        <a role="button" href="#" class="custom-modal__close" type="button" @click.prevent="open1=false">
          <span class="mi mi-cross"></span>
        </a>
      </template>

      <div class="confectionModal">
        <div class="confectionModal-top">
          <img class="confectionModal-image img-responsive promoPacketModal__img" alt="Pakiet promocji" src="/media/promo_package_BN26.webp">
        </div>

        <div class="confectionModal-content">
          <h2 class="confectionModal-title">Świąteczna ulotka z promocjami</h2>
          <section class="confectionModal-descriptions">
            <p>
              Z kartami Pluxee Twoi pracownicy mogą otrzymać świąteczną ulotkę z pakietem promocji, które znacząco zwiększają realną wartość upominku.
              Dzięki nim pieniądze przekazane pracownikom na kartach i kuponach Pluxee mają w rzeczywistości o wiele wyższą wartość.
          </p>
          </section>
          <section>
            <p>
              <a href="https://www.pluxee.pl/uzytkownik/pakiet-promocji/" target="_blank" rel="noopener">
                Dowiedz się więcej o korzyściach, jakie niesie pakiet promocji dla Twoich pracowników.
              </a>
            </p>
          </section>
        </div>
      </div>
      <div class="custom-modal__controls">
        <button type="button" @click="open1=false" class="btn btn-primary btn-lg">OK</button>
      </div>
    </modal>
  </section>
</template>

<script>
export default {
  name: 'PromoPacketModal',
  data() {
    return {
      open1: false,
    };
  },
};
</script>

<style scoped>

</style>
